import axios from "axios";
export default axios.create({
  // baseURL: "https://api.cobmindex.com/api/v1/",
  // baseURL: "http://ec2-35-180-160-9.eu-west-3.compute.amazonaws.com/api/",
  
  //test
  // baseURL: "http://ec2-54-237-215-82.compute-1.amazonaws.com/api/",
  
  //NOAM
   baseURL: "https://backapi.ismbonline.org/api/",
   
    

});